// extracted by mini-css-extract-plugin
export default {"container":"DepositResult_container__LYbb8","statusImg":"DepositResult_statusImg__VIDEb","statusText":"DepositResult_statusText__tFM8b","button":"DepositResult_button__QiQNF"};